<template>
  <div class="col-12 order-contracts">
    <el-card>
      <div style="display: flex" class="sales-title">
        <h4>Contracts</h4>
        <h4 class="sub" style="order: 2; line-height: 32px; cursor: pointer">
          <base-button @click="openContract" size="sm" type="primary"
            style="width: 130px; font-size: 12px; padding: 6px 14.5px"
            v-if="useOrder.getOrderFunctionPermission('NewContract')?.enable" :disabled="useOrder.getOrderFunctionPermission('NewContract')?.disable
              ">
            <el-icon style="margin-right: 6px">
              <Plus />
            </el-icon>
            New Contract
          </base-button>
        </h4>
        <h4 class="sub" style="order: 2; line-height: 32px; cursor: pointer">
          <base-button v-if="false" @click="openInstallment" size="sm" type="primary"
            style="width: 130px; font-size: 12px; padding: 6px 14.5px">
            <el-icon style="margin-right: 6px">
              <Plus />
            </el-icon>
            Installment
          </base-button>
        </h4>
      </div>
      <el-col :span="24">
        <el-table :data="Contracts.filter((t) => t.status !== 'Revised')" style="width: 100%"
          header-row-class-name="header-row" table-layout="auto" v-if="Contracts.length > 0" row-key="id">
          <el-table-column />
          <el-table-column>
            <template #default="{ row }">
              <div>
                <base-button v-if="row.functions &&
                  (JSON.parse(row.functions).find(
                    (t) => t.alias === 'CopyContract'
                  )?.enable ||
                    false)
                  " type="primary" @click="CopyClick(row)" :disabled="row.functions &&
    JSON.parse(row.functions).find(
      (t) => t.alias === 'CopyContract'
    )?.disable
    ">Copy</base-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="" align="center">
            <template #default="scope">
              <div v-if="scope.row.isApprove">
                <el-checkbox v-model="scope.row.ischecked"></el-checkbox>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="useAuthority.GetAuthority('SuFunction_GenerateJobOrder') && Order.status != 'Completed'"
            prop="" label="" align="center">
            <template #default="scope">
              <div v-if="scope.row.isDownJob">
                <el-checkbox v-model="scope.row.ischeckedjob"></el-checkbox>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="action" label="Contract Type" style="text-transform: none"
            :formatter="formatter_contractType">
          </el-table-column>
          <el-table-column prop="companyEntityCode" label="Entity"></el-table-column>
          <el-table-column prop="subgroupCode" label="Subgroup Code"></el-table-column>
          <el-table-column prop="campaignPeriod" label="Campaign Period"></el-table-column>
          <el-table-column prop="contractNumberFull" label="Contract No.">
            <template #default="scope">
              <el-link type="primary" target="_blank" :underline="false" style="text-decoration: underline"
                @click="openFile(scope.row)">{{ scope.row.contractNumberFull }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="createByName" label="Create By"></el-table-column>
          <el-table-column prop="createDate" label="Create Date" :formatter="formatterCellDateTime">
          </el-table-column>
          <el-table-column prop="status" label="Status">
            <template #default="scope">
              <div :style="{
                color:
                  scope.row.status === 'Approving' ? '#b60005' : undefined,
              }">
                {{ scope.row.status }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="signed" label="Signed">
            <template #default="scope">
              <div :style="{
                color:
                  scope.row.signed === 'Approving' ? '#b60005' : undefined,
              }">
                {{ scope.row.signed }}
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <span style="white-space: pre-line">{{
                'Approval\nHistory'
              }}</span>
            </template>
            <template #default="scope">
              <div>
                <el-button link @click="OpenApprovalHistory(scope.row.contract_Id)">
                  <el-icon>
                    <search />
                  </el-icon>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <span style="white-space: pre-line">{{ 'Contract\nInfo' }}</span>
            </template>
            <template #default="scope">
              <div>
                <el-button link @click="OpenBookingInfo(scope.row, 'ContractInfo')">
                  <el-icon>
                    <search />
                  </el-icon>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <span style="white-space: pre-line">{{ 'Media\nItems' }}</span>
            </template>
            <template #default="scope">
              <div>
                <el-button link @click="OpenBookingInfo(scope.row, 'MediaItems')">
                  <el-icon>
                    <search />
                  </el-icon>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <span style="white-space: pre-line">{{ 'Internal\nSplit' }}</span>
            </template>
            <template #default="scope">
              <div>
                <el-button link @click="OpenBookingInfo(scope.row, 'InternalSplit')">
                  <el-icon :style="{
                    color: scope.row.bHasCommission ? '#f56c6c' : '',
                  }">
                    <search />
                  </el-icon>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <span style="white-space: pre-line">{{
                'Payment\nSchedule'
              }}</span>
            </template>
            <template #default="scope">
              <div>
                <el-button link @click="OpenBookingInfo(scope.row, 'Payment')">
                  <el-icon :style="{
                    color: scope.row.bHasSpecialPaymentTerm ? '#f56c6c' : '',
                  }">
                    <search />
                  </el-icon>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <span style="white-space: pre-line">{{ 'Draft\nContract' }}</span>
            </template>
            <template #default="scope">
              <div>
                <el-button link @click="OpenBookingInfo(scope.row, 'DraftContract')">
                  <el-icon>
                    <search />
                  </el-icon>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <span style="white-space: pre-line">{{
                'Additional\nInfo'
              }}</span>
            </template>
            <template #default="scope">
              <div>
                <el-button link @click="OpenBookingInfo(scope.row, 'AdditionalInfo')">
                  <el-icon>
                    <search />
                  </el-icon>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="" fixed="right" width="50">
            <template #default="scope">
              <div class="operation">
                <div v-if="scope.row.isApprove">
                  <base-button class="btn-approve" type="primary" @click="OpenApproveDialog([scope.row])">
                    APPROVE
                  </base-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>

      <div style="display: flex" class="input-with-check-box">
        <base-button type="primary" v-if="useOrder.getOrderFunctionPermission('BulkApprove').enable"
          :disable="useOrder.getOrderFunctionPermission('BulkApprove').disable" @click="BulkApproveContract()">
          Bulk Approve
        </base-button>

        <el-dropdown @command="handleCommand" v-if="false">
          <base-button type="primary">
            Action
            <el-icon class="el-icon--right">
              <ArrowDown />
            </el-icon>
          </base-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="bulkApprove" :disabled="useOrder.getOrderFunctionPermission('BulkApprove').disable
                ">Bulk Approve</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <base-button type="primary" v-if="ShowGenerateJobOrder" style="margin-left: 15px;"
          @click="DwonloadJobOrderWord()">
          Generate Job Order
        </base-button>

      </div>
    </el-card>
  </div>
  <div class="approve-dialog">
    <el-dialog title="Approve" v-model="ApproveDialog" :width="500">
      <div>Comment</div>
      <div>
        <el-input v-model="ApproveComment" :rows="2" placeholder="Comment" type="textarea"></el-input>
      </div>
      <template #footer>
        <base-button type="primary" @click="ApproveContract('Accept')">Approve</base-button>
        <base-button @click="ApproveContract('Reject')">Reject</base-button>
      </template>
    </el-dialog>
  </div>
  <div v-if="ApprovalHistoryDialog">
    <approval-history v-model="ApprovalHistoryDialog" :cId="ApprovalContractId" />
  </div>
</template>

<script setup>
// vue
import { ref, reactive, onBeforeMount } from 'vue';
import baseButton from '@/components/newUI/BaseButton';
import router from '@/router';
// tool
import { Search, ArrowDown, Plus } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { formatterCellDateTime } from '@/assets/js/formatter';
import { useOrderStore } from '@/store/order';
import { useContractStore } from '@/store/contract';
import { useAuthorityStore } from '@/store/authority';
import { routeParamsStore } from '@/store/routeParams';
import { storeToRefs } from 'pinia';
import approvalHistory from './ApprovalHistory';
import contractnet from '@/network/contractnet';
import booknet from '@/network/booknet';
import { id } from 'element-plus/es/locale';

const useAuthority = useAuthorityStore();
const emits = defineEmits(['open']);

const useContract = useContractStore();

const messageConfig = require('@/models/messageConfig.js');

// UseOrder
const useOrder = useOrderStore();
const { Contracts, Id, OrderNumber, Order } = storeToRefs(useOrder);

const ApproveDialog = ref(false);
const ApprovalHistoryDialog = ref(false);
const OrderContracts = ref([]);
const ApprovalContractId = ref('');
const ApproveComment = ref();
//是否显示Generate Job Order按钮
const ShowGenerateJobOrder = ref(false);
onBeforeMount(() => {
  ShowGenerateJobOrder.value = useAuthority.GetAuthority('SuFunction_GenerateJobOrder')
    && Order.value.status != 'Completed'
    && Contracts.value.filter((t) => t.status !== 'Revised' && t.isDownJob === true).length > 0
});

const isReviseUnlock = (row) => {
  return useAuthority.isOrderTop() && row.isReviseUnlock;
};

const NewContracts = () => {
  OrderContracts.value = Contracts.value.filter((t) => t.status !== 'Revised');

  if (OrderContracts.value.length > 0) {
    OrderContracts.value.forEach((entity) => {
      var signedFiles = JSON.parse(entity.signedContractFile);
      entity.signedFile =
        signedFiles?.[signedFiles.length - 1]?.split(';')?.[1] || '';
      if (entity.signedFile) {
        entity.signedFile = process.env.VUE_APP_HOST + entity.signedFile;
      }

      entity.children =
        Contracts.value.filter(
          (t) =>
            t.contractDraftNo == entity.contractDraftNo &&
            t.status === 'Revised'
        ) || [];

      if (entity.children?.length > 0) {
        entity.children = entity.children.sort((a, b) => b.id - a.id);

        entity.children.map((t) => {
          var children_SignedFiles = JSON.parse(t.signedContractFile);
          t.signedFile =
            children_SignedFiles?.[children_SignedFiles.length - 1]?.split(
              ';'
            )?.[1] || '';

          if (t.signedFile) {
            t.signedFile = process.env.VUE_APP_HOST + t.signedFile;
          }
        });
      }
    });
  }
};
NewContracts();

// 审批实体
const ApproveModel = reactive({
  OrderId: useOrder.Id,
  Unit: useOrder.Unit.alias,
});

// 批量审批
const BulkApproveContract = () => {
  var message =
    useOrder.getOrderFunctionPermission('BulkApprove').disableMessage;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  var processFlowTaskIds = Contracts.value
    .filter((t) => t.ischecked)
    .map((t) => t.processFlowTaskId);

  var contractIds = Contracts.value
    .filter((t) => t.ischecked)
    .map((t) => t.contractId);

  if (processFlowTaskIds.length < 1) {
    ElMessage({
      message: 'Please select contract(s).',
      type: 'warning',
    });
    return;
  }

  var bHasNoPermissApprove =
    Contracts.value.filter(
      (t) => contractIds.indexOf(t.contractId) >= 0 && !t.isApprove
    ).length > 0;
  if (bHasNoPermissApprove) {
    ElMessage({
      message:
        'Approve is not allowed as some contracts have not been submitted.',
      type: 'warning',
    });
    return;
  }

  OpenApproveDialog(Contracts.value.filter((t) => t.ischecked));
};
const DwonloadJobOrderWord = () => {


  var AgreementNo = Contracts.value
    .filter((t) => t.ischeckedjob)
    .map((t) => t.contractNumberFull).join(';');

  var ContractIds = Contracts.value
    .filter((t) => t.ischeckedjob)
    .map((t) => t.contractId).join(',');

  if (AgreementNo.length < 1) {
    ElMessage({
      message: 'Please select contract(s).',
      type: 'warning',
    });
    return;
  }
  booknet.DwonloadJobOrderWord(Id.value,
    OrderNumber.value,
    AgreementNo,
    ContractIds,).then((res) => {
      let blob = new Blob([res.data], {
        type: 'application/pdf;charset=utf-8',
      });
      let downloadElement = document.createElement('a');
      const href = window.URL.createObjectURL(blob);
      let contentDisposition = res.headers['content-disposition'];
      var patt = new RegExp('filename*=([^;]+\\.[^\\.;]+);*');
      var result = patt.exec(contentDisposition);
      var filename = decodeURI(result?.[1] || 'order.docx');
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.download = filename;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      window.URL.revokeObjectURL(href);
    });
};

// 点击Approve按钮
const OpenApproveDialog = (contracts) => {
  // if (contracts.find((t) => !t.isApprove)) {
  //   ElMessage({
  //     message: 'Some contracts have not been submitted.',
  //     type: 'warning',
  //   });
  //   return;
  // }
  ApproveComment.value = '';

  if (contracts.length == 0) {
    return;
  }

  ApproveModel.ApproveDatas = contracts.map((t) =>
    NewApproveData(
      t.processFlowName,
      t.processFlowTaskId,
      t.contract_Id,
      t.contractId
    )
  );

  ApproveDialog.value = true;
};

// const ReviseUnlock = (id) => {
//   const contractnet = require('@/network/contractnet').default;
//   contractnet.ReviseUnlock(id).then((res) => {
//     if ((res.data.message || '') !== '') {
//       ElMessage({
//         message: res.data.message,
//         type: 'warning',
//       });
//       return;
//     }

//     var datas = Contracts.value.filter((t) => t.contract_Id === id);
//     if (datas.length > 0) {
//       datas.map((t) => (t.isReviseUnlock = false));
//     }
//   });
// };

// 审批
const ApproveContract = async (ApproveAction) => {
  if (ApproveAction === 'Reject' && !ApproveComment.value) {
    ElMessage({
      message: 'Please fill in the Comment',
      type: 'warning',
    });
    return;
  }

  ApproveDialog.value = false;

  //ApproveModel.ApproveAction = ApproveAction;

  ApproveModel.ApproveDatas.map((t) => {
    t.ApproveAction = ApproveAction;
    t.ApproveComment = ApproveComment.value;
  });

  //提交审批
  const message = await useContract
    .approveContract(ApproveModel)
    .then((res) => res);
  if (message && message !== 'OK') {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  NewContracts();
};

const OpenApprovalHistory = (id) => {
  ApprovalContractId.value = id;

  ApprovalHistoryDialog.value = true;
};

const NewApproveData = (flow_name, taskid, contract_id, contractId) => {
  var new_approvedata = {
    ApproveFlowName: 'CONTRACT_PROCESS_BB',
    ProcessFlowTaskId: taskid,
    ApproveAction: 'Approve',
    Contract_Id: contract_id,
    ContractId: contractId,
  };

  if (flow_name) {
    new_approvedata.ApproveFlowName = flow_name;
  }
  return new_approvedata;
};

const OpenBookingInfo = async (item, tabName) => {
  var contractNo = item.contractNumber;

  useContract.activeName = tabName;
  useContract.OrderId = item.orderId;
  useContract.Id = item.contractId;
  useContract.mode = 'view';

  if (tabName === 'InternalSplit' && !item.bEnterInternalSplit) {
    ElMessage({
      message: 'Insufficient data to generate internal split',
      type: 'warning',
    });
    return false;
  }
  if (tabName === 'PaymentSchedule' && !item.bEnterPaymentSchedule) {
    ElMessage({
      message: 'Insufficient data to generate payment schedule',
      type: 'warning',
    });
    return false;
  }

  emits('open', {
    tabName,
    contractNo,
    id: item.contractId,
    cId: item.contract_Id,
    bDraftContract: item.bDraftContract,
  });
};

// Event: 点击New Contract
const openContract = async () => {
  var message =
    useOrder.getOrderFunctionPermission('NewContract')?.disableMessage;

  if (message) {
    ElMessage({
      message: message,
      type: 'warning',
    });
    return;
  }

  if (useOrder.Id === 0 || !useOrder.disabled) {
    ElMessage({
      message: messageConfig.getMessage('noEdit'),
      type: 'warning',
    });
    return;
  }

  useContract.activeName = 'ContractInfo';
  const useParam = routeParamsStore();
  // 更新页面参数
  useParam.setPageParam({
    key: '',
    mode: 'edit',
  });

  // 预设基本信息
  useContract.$reset();
  useContract.OrderId = Id.value;
  useContract.OrderNumber = useOrder.OrderNumber;
  useContract.cId = '';
  useContract.mode = 'edit';
  useContract.Id = 0;

  router.push({
    name: 'contract',
    query: {
      ContractNo: '',
      cId: '',
    },
  });
};
// Event: 点击New Installment
const openInstallment = async () => {
  if (useOrder.Id === 0 || !useOrder.disabled) {
    ElMessage({
      message: messageConfig.getMessage('noEdit'),
      type: 'warning',
    });
    return;
  }

  var contractIds = Contracts.value
    .filter((t) => t.ischecked)
    .map((t) => t.contractId);
  if (contractIds.length < 1) {
    ElMessage({
      message: messageConfig.getMessage('selectedinstallment'),
      type: 'warning',
    });
    return;
  }

  ElMessage({
    message: '努力開發中!',
    type: 'warning',
  });
};
// #region Element Table Column 格式化
// 日期格式化
// const formatterdate = (row, column, cellValue) => {
//   return formatter_date(cellValue, 'DD/MM/YYYY');
// };

const formatter_contractType = (row, column, cellValue) => {
  if (cellValue === 'media') {
    return 'Media';
  } else if (cellValue === 'production') {
    return 'Production';
  } else if (cellValue === 'media+production') {
    return 'Media + Production';
  } else if (cellValue === 'media&production') {
    return 'Media & Production';
  }

  return '';
};

const openFile = (param) => {
  const { contract_Id, action, signed, draft_Id } = param;
  const contractnet = require('@/network/contractnet').default;
  const urlJs = require('@/assets/js/URLParams').default;


  //upload signed pdf後, 不論是否已提交或審批 > 顯示最後一個上載的PDF
  contractnet.downloadContract(contract_Id, action).then((res) => {
    if (res.status == 201) {//是否存在
      if (draft_Id) {
        contractnet.DownloadPDF(draft_Id).then((res1) => {
          if (res1.status == 200) {
            urlJs.openFile(res1);
          }
        });
      } else {
        ElMessage({
          message: messageConfig.getMessage('draftvalid1'),
          type: 'warning',
        });
        return;
      }
    } else {
       //如果上传文件大于1,跳转DraftContract页面
       if (param.signedContractFile && JSON.parse(param.signedContractFile).length > 1) {
          OpenBookingInfo(param, 'DraftContract')
          return;
        }
      urlJs.openFile(res);
    }
  });

  //  // 如果未上传合同, 同Contract Draft PDF功能
  //   if (signed === 'Open') {
  //     if (draft_Id) {
  //       contractnet.DownloadPDF(draft_Id).then((res) => {
  //         urlJs.openFile(res);
  //       });
  //     } else {
  //       ElMessage({
  //         message: messageConfig.getMessage('draftvalid1'),
  //         type: 'warning',
  //       });
  //       return;
  //     }
  //   } else {
  //     contractnet.downloadContract(contract_Id, action).then((res) => {
  //       if ((res.data.message || '') !== '') {
  //         ElMessage({
  //           message: res.data.message,
  //           type: 'warning',
  //         });
  //       }

  //       const urlJs = require('@/assets/js/URLParams').default;
  //       urlJs.openFile(res);
  //     });
  //   }
};
// #endregion

const handleCommand = (command) => {
  if (command == 'bulkApprove') {
    BulkApproveContract();
  }
};

const CopyClick = async (row) => {
  var permision = JSON.parse(row.functions || '[]').find(
    (t) => t.alias == 'CopyContract'
  );

  var message = permision?.disabledMessage || permision?.alertMessage;

  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  ElMessageBox.confirm(
    'Confirm to copy as production contract?',
    'Copy Contract',
    {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).then(async () => {
    var res = await contractnet
      .CopyContract(row.contract_Id)
      .then((res) => res);

    if (res.data.message) {
      ElMessage({
        message: res.data.message,
        type: 'warning',
      });

      return;
    }

    if (res.data.contract) {
      var contracts = useOrder.getState_Contracts();
      var newcontracts = [...contracts];

      newcontracts.push(res.data.contract);
      useOrder.setState_Contracts(newcontracts);
    }
  });
};
</script>

<style scoped>
.table>thead>tr>th,
.el-table table>thead>tr>th {
  text-transform: none;
}

.new-order h4 {
  color: #3b291d;
}

.new-order h5 {
  color: #423022;
}

.sales-title h4.sub {
  margin-left: 54px;
  display: inline-block;
  font-size: 11px;
}

.sales-title i {
  position: relative;
  top: -1px;
  right: 4px;
}

.new-order .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 6px;
}

.advertiser-field .form-group.has-label label::after {
  content: '【 Contracting Party 】';
  color: #d05c5f;
}

.sub-info {
  font-size: 10px;
  color: #9a9a9a;
  margin-left: 30px;
}

.sub-info .dot {
  width: 5px;
  height: 5px;
  background-color: rgb(169, 169, 169);
  display: inline-block;
  border-radius: 50%;
  top: -1px;
  position: relative;
  right: 2px;
}

.Rectangle {
  width: 160px;
  height: 32px;
  margin: 20px 1474.6px 0 0;
  padding: 6px 15px 6px 58px;
  border-radius: 6px;
  background-image: linear-gradient(to left, #eb6100, #b60005);
  color: #fff;
}

.order-contracts .btn.btn-approve,
.order-contracts .btn.btn-approve:hover {
  width: 90px;
}

.order-contracts .operation .btn {
  padding: 5px 0px;
  border-radius: 50px;
}
</style>
